module.exports = __webpack_public_path__ + "static/media/emojiWink.32c288e5.png";